module.exports = __webpack_public_path__ + "static/media/forward_slash.ef96b07d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/forward_slash.svg
// module id = 212
// module chunks = 1